import { appGridApiAtom, appGridStateAtom } from "@/components/AppGrid/AppGrid";
import { ColDef } from "@ag-grid-community/core";
import {
  ActionIcon,
  Button,
  Group,
  SimpleGrid,
  Stack,
  Switch,
  Tooltip,
} from "@mantine/core";
import { useAtomValue } from "jotai";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";

export const ColumnToggles = ({ colDefs }: { colDefs: ColDef[] }) => {
  const gridApi = useAtomValue(appGridApiAtom);
  const gridState = useAtomValue(appGridStateAtom);

  return (
    <Stack>
      <Group gap={"xs"}>
        <Button
          size="sm"
          flex={1}
          onClick={() => {
            gridApi?.setColumnsVisible(
              colDefs.map((col) => col.field!),
              false,
            );
          }}
          disabled={
            gridState?.columnVisibility?.hiddenColIds.length === colDefs.length
          }
        >
          Hide All
        </Button>
        <Button
          size="sm"
          flex={1}
          onClick={() => {
            gridApi?.setColumnsVisible(
              colDefs.map((col) => col.field!),
              true,
            );
          }}
          disabled={!gridState?.columnVisibility?.hiddenColIds.length}
        >
          Show All
        </Button>
        <Tooltip label="Restore Defaults">
          <ActionIcon
            h={37}
            w={37}
            variant="light"
            size="lg"
            onClick={() => {
              gridApi?.resetColumnState();
            }}
          >
            <MdOutlineSettingsBackupRestore />
          </ActionIcon>
        </Tooltip>
      </Group>
      <SimpleGrid cols={2}>
        {colDefs
          .sort((a, b) => (a.field || "").localeCompare(b.field || ""))
          .map((col) => (
            <Switch
              key={col.field}
              label={(
                col.headerName || camelCaseToTitleCase(col.field || "")
              ).replace("🏢", "Real Estate Included")}
              checked={
                !gridState?.columnVisibility?.hiddenColIds.includes(col.field!)
              }
              onChange={(event) => {
                const checked = event.currentTarget.checked;
                gridApi?.setColumnsVisible([col.field!], checked);
              }}
            />
          ))}
      </SimpleGrid>
    </Stack>
  );
};

const camelCaseToTitleCase = (str: string) => {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};
